<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full mb-base">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="name"
            label="Venue Name*"
            v-model="venue.name"
          />
          <span class="text-danger text-sm">{{ errors.first('name') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
            name="venue-type"
            v-model="venue.type"
            label="Type of Venue"
            class="select-large w-full"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in venueTypes"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="displayname"
            label="Display Name*"
            v-model="venue.displayName"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('displayname')"
          >{{ errors.first('displayname') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
            name="venue-language"
            v-model="venue.lang"
            label="Language*"
            class="select-large w-full"
          >
            <vs-select-item
              v-validate="'required'"
              data-vv-validate-on="blur"
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in venueLangs"
            />
          </vs-select>
          <span class="text-danger text-sm">{{ errors.first('venue-language') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-street"
            label="Street*"
            v-model="venue.street"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-street') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            name="venue-house-number"
            label="House number"
            v-model="venue.houseNumber"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" name="venue-suffix" label="Suffix" v-model="venue.suffix" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-postal-code"
            label="Postal Code*"
            v-model="venue.postalCode"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-postal-code') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-city"
            label="City*"
            v-model="venue.city"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-city') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-country"
            label="Country*"
            v-model="venue.country"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-country') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-timezone"
            label="Timezone*"
            v-model="venue.timezone"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-timezone') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-telephone"
            label="Telephone*"
            v-model="venue.telephone"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-telephone') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-latitude"
            label="Latitude*"
            v-model="venue.latitude"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-latitude') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="venue-longitude"
            label="Longitude*"
            v-model="venue.longitude"
          />
          <span class="text-danger text-sm">{{ errors.first('venue-longitude') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            type="number"
            min="1"
            oninput="validity.valid||(value='');"
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="maxBooking"
            label="Max taxi bookings*"
            v-model="venue.maxBooking"
          />
          <span class="text-danger text-sm">{{ errors.first('maxBooking') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            name="venue-extra-info"
            label="Extra info for driver"
            v-model="venue.infoDriver"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            name="venue-company-comment"
            label="Company comment field"
            v-model="venue.companyComment"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            name="venue-internal-comment"
            label="Internal comment field"
            v-model="venue.internalComment"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" :disabled="!validateForm" @click="addVenue">Submit</vs-button>
          <!-- <vs-button color="warning" type="border" class="mb-2" @click="input9 = input10 = input11 = input12 = ''; check3 = false;">Reset</vs-button> -->
        </div>
      </div>
    </div>
    <div class="vx-col md:w-1/2 w-full mb-base">
      <div class="vx-row mb-2 mt-6">
        <div class="vx-col w-full">
          <gmap-autocomplete class="vs-inputx vs-input--input normal" @place_changed="setPlace"></gmap-autocomplete>
        </div>
      </div>

      <gmap-map
        ref="gmap"
        :center="center"
        :zoom="15"
        style="width: 100%; height: 500px"
        @click="getInfo($event)"
      >
        <gmap-marker :position="position"></gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import { _types, _save, _show, _update } from "@/services/Venue";
import { _list } from "@/services/Language";
export default {
  data() {
    return {
      venue: {
        name: "",
        type: "",
        displayName: "",
        lang: "",
        street: "",
        houseNumber: "",
        suffix: "",
        postalCode: "",
        city: "",
        country: "",
        timezone: "",
        telephone: "",
        latitude: "",
        longitude: "",
        maxBooking: "",
        infoDriver: "",
        companyComment: "",
        internalComment: "",
        placeId: "",
        companyId: "",
      },
      editedIndex: -1,
      venueBookingCount: 0,
      position: {
        lat: 0,
        lng: 0,
      },
      currentPlace: null,
      venueTypes: [],
      venueLangs: [],
      center: {
        lat: this.$store.state.company.latitude,
        lng: this.$store.state.company.longitude,
      },
      infoContent: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
    };
  },
  watch: {
    "$store.state.company.companyID"() {
      this.center.lat = this.$store.state.company.latitude;
      this.center.lng = this.$store.state.company.longitude;
    },
    currentPlace() {
      this.addMarker();
    },
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.venue.name != "" &&
        this.venue.displayName != "" &&
        this.venue.lang != "" &&
        this.venue.street != "" &&
        this.venue.postalCode != "" &&
        this.venue.city != "" &&
        this.venue.country != "" &&
        this.venue.timezone != "" &&
        this.venue.telephone != "" &&
        this.venue.latitude != "" &&
        this.venue.longitude != "" &&
        this.venue.maxBooking != ""
      );
    },
  },
  mounted() {
    //  if(this.$store.getters['company/getCompanyID']){
    //   }
    //   else{
    //      this.$vs.notify({
    //         title: 'Alert',
    //         text: 'Set your default company first ',
    //         iconPack: 'feather',
    //         position: 'bottom-right',
    //         icon: 'icon-alert-circle',
    //         color: 'warning'
    //       })
    // }
    _types().then((response) => {
      this.venueTypes = response.data.data;
    });
    _list().then((response) => {
      this.venueLangs = response.data.data;
    });
    if (this.$route.params.id) {
      this.editedIndex = this.$route.params.id;
      this.getVenue();
    }
  },
  methods: {
    fetchingData(lat, lng) {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCjUoqh0yI0tIWeo3a9jzlFRQXe9N4hu9M`
      )
        .then((result) => result.json())
        .then(
          (result) => {
            this.venue.placeId = result.results[0].place_id;
            fetch(
              `https://maps.googleapis.com/maps/api/place/details/json?place_id=${result.results[0].place_id}&key=AIzaSyCjUoqh0yI0tIWeo3a9jzlFRQXe9N4hu9M`
            )
              .then((result) => result.json())
              .then((place) => {
                place = place.result;
                this.setPlace(place, true);
                this.position = { lat: lat, lng: lng };
                this.center = { lat: lat, lng: lng };
              });
          },
          (error) => {
            console.error(error);
          }
        );
    },
    getInfo(event) {
      const marker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      event.zoom = 15;
      this.venue.latitude = marker.lat;
      this.venue.longitude = marker.lng;
      this.position = marker;
      this.center = marker;
      this.fetchingData(marker.lat, marker.lng);
    },

    setPlace(place, watcher = false) {
      this.removeFilledData();
      // for city field
      for (var i = 0; i < place.address_components.length; i++) {
        for (var b = 0; b < place.address_components[i].types.length; b++) {
          if (
            place.address_components[i].types[b] ==
            "administrative_area_level_1"
          ) {
            this.venue.city = place.address_components[i].long_name;
            break;
          }
        }
      }
      // for country field
      for (var k = 0; k < place.address_components.length; k++) {
        for (var a = 0; a < place.address_components[k].types.length; a++) {
          if (place.address_components[k].types[a] == "country") {
            this.venue.country = place.address_components[k].long_name;
            break;
          }
        }
      }
      for (var j = 0; j < place.address_components.length; j++) {
        for (var c = 0; c < place.address_components[j].types.length; c++) {
          if (place.address_components[j].types[c] == "postal_code") {
            this.venue.postalCode = place.address_components[j].long_name;
            break;
          }
        }
      }

      this.venue.street = place.formatted_address;
      this.venue.telephone = place.international_phone_number;
      this.venue.placeId = place.place_id;
      if (watcher) {
        this.setTimezone(place.utc_offset);
      } else {
        this.currentPlace = place;
        this.setTimezone(place.utc_offset_minutes);
      }
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.venue.latitude = marker.lat;
        this.venue.longitude = marker.lng;
        this.position = marker;
        this.center = marker;
      }
    },
    removeFilledData() {
      this.venue.city = "";
      this.venue.country = "";
      this.venue.street = "";
      (this.venue.postalCode = ""), (this.venue.timezone = "");
      this.venue.telephone = "";
      this.currentPlace = "";
    },
    // toggleInfoWindow(marker, idx) {
    //     this.infoWindowPos = marker.position;
    //     this.infoContent = marker.infoText;
    //     //check if its the same marker that was selected if yes toggle
    //     if (this.currentMidx == idx) {
    //         this.infoWinOpen = !this.infoWinOpen;
    //     }
    //     //if different marker set infowindow to open and reset current marker index
    //     else {
    //         this.infoWinOpen = true;
    //         this.currentMidx = idx;
    //     }
    //   },
    addVenue() {
      let data = this.venue;
      if (this.editedIndex == -1) {
        data.companyId = this.$store.getters["company/getCompanyID"];
        _save(data)
          .then((response) => {
            this.$vs.notify({
              title: response.data.responseTitle,
              text: response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
            this.$router.push("/venues");
          })
          .catch((error) => {
            this.$vs.notify({
              title: error.data.responseTitle,
              text: error.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          });
      } else {
       if (
          this.venueBookingCount > 0 &&
          this.venue.companyId != this.$store.getters["company/getCompanyID"]
        ) {
          this.$vs.notify({
            title: "Company Change",
            text: "Cannot change company of venue",
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        } else {
          data.companyId = this.$store.getters["company/getCompanyID"];

          _update(this.editedIndex, data)
            .then((response) => {
              this.$vs.notify({
                title: response.data.responseTitle,
                text: response.data.responseMessage,
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
              });
              this.$router.go(-1);
            })
            .catch((error) => {
              if (error.response.status == 422) {
                this.errors.add(error.response.data["errors"]);
              } else {
                this.$vs.notify({
                  title: error.response.data.responseTitle,
                  text: error.response.data.responseMessage,
                  iconPack: "feather",
                  icon: "icon-cross-circle",
                  color: "danger",
                });
              }
            });
        }
      }
    },
    setTimezone(val) {
      var hours = Math.floor(val / 60);
      if (hours < 0) {
        hours = Math.abs(hours);
        hours = hours < 10 ? "-0" + hours : "-" + hours;
      } else {
        hours = hours < 10 ? "0" + hours : hours;
      }
      var minutes = val % 60;
      var timezoneStr = "";
      timezoneStr = minutes ? hours + ":" + minutes : hours + ":00";

      this.venue.timezone = val < 0 ? timezoneStr : "+" + timezoneStr;
    },
    getVenue() {
      _show(this.editedIndex).then((response) => {
        this.venue = response.data.obj.venue;
        // console.log(response.data.obj);
        // console.log(this.venue);
        const marker = {
          lat: parseFloat(this.venue.latitude),
          lng: parseFloat(this.venue.longitude),
        };
        this.position = marker;
        this.center = marker;
        this.venueBookingCount = response.data.obj.booking_count;
      });
    },
  },
};
</script>
